import { useEvent, useState } from 'hooks'
import { ChangeEvent } from 'react'
import { debounce } from 'utils'
import { selectors } from './selector'
import { constant } from './constant'

type State = {
	targets: NodeListOf<HTMLInputElement>
}

export const InputChangeHandler = (() => {
	const { state, setState } = useState<State>()

	const initTargets = () => {
		const { targets } = state

		Array.from(targets)
			.filter((target) => target.hasAttribute(constant.attribute.url))
			.forEach((target) => initTarget(target))
	}

	const initTarget = (target: HTMLInputElement) => {
		const event = useEvent<ChangeEvent<HTMLInputElement>>(target, 'change')
		event.register(
			debounce(({ e }: { e: ChangeEvent<HTMLInputElement> }) => {
				let url = e.target.getAttribute(constant.attribute.url)

				if (url === null) {
					return
				}

				url = url.replace(constant.parameters.valuePlaceholder, encodeURIComponent(e.target.value))

				// @ts-ignore
				$.nette.ajax({
					type: 'POST',
					url,
				})
			}),
		)
	}

	const init = () => {
		setState({
			targets: selectors.getTargets(),
		})
		initTargets()
	}

	return {
		init,
		constant,
		selectors,
	}
})()
